/* eslint-disable no-return-assign */
import { observer } from 'mobx-react-lite';
import React, { useContext, useRef, useEffect, useState } from 'react'; //eslint-disable-line
import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import goTrackerConfig from 'goTrackerConfig';

const MessageOverride = observer(() => {
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);
  const messagesRef = useRef([]);
  const hidden = locationStore.gotMessage ? '' : 'hidden';
  useEffect(() => {
    setTimeout(() => {
      if(locationStore.isTripTakeover) { locationStore.setGotMessage(false);}
    }, goTrackerConfig.takoverMessageInterval || 5000);
  }, [locationStore.gotMessage ]);

  console.count('messageTakeover Rendering');
  return locationStore.gotMessage ? (<div style={{ backgroundColor: 'rgba(0, 128, 0, 1)', zIndex: '10001', width: '100%', minHeight: '100%', left: '0', right: '0', position: 'absolute', visibility: hidden }}>
    <span className="scrolling-messages">
      {locationStore.scrollingMessages && locationStore.scrollingMessages.map((m, i) => {
        if(m === undefined || !m.isTakeover)  {
          return (
            <p></p>
          );
        }
        if(m.setting[0].name === 'IsTripTakeover') {
          locationStore.setScreenTakover(true);
        }
        let messages = {};
        if(m.text) {
          messages = m.text.find(t => t.language === viewStore.languageName);
        }
        const busMsg = m[`${viewStore.languageName.toLowerCase()}`] ?? '';
        if(busMsg) {
          messages.text = busMsg;
        }

        const busDetailMsg = m.message !== null ? m.message : m.frenchMessage ?? '';
        if(busDetailMsg) {
          messages.text = busDetailMsg;
        }
        if (messages === undefined || messages.text === undefined) return '';

        const scrollingMessages = `${messages.text} `;

        return (
        // <p key={i} ref={e => messagesRef.current[i] = e} className="message">{scrollingMessages}</p>
          <p key={i} ref={e => messagesRef.current[i] = e} style={{fontSize: '3em'}}>{scrollingMessages}</p>
        );
      })}
    </span>
  </div>)
    : <div></div>;
});


export default MessageOverride;

